<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <polygon points="4,4 14,4 20,10 20,20 10,20 4,14"/>
    <path d="M9 9 L15 9 L15 15"/>
    <circle cx="11" cy="11" r="0.6" fill="currentColor"/>
  </svg>
</template>
